import type { ClinicPhysicianResponse } from '../services/api/types.gen';

export function truncateJoinedList(items: string[], maxShown: number): string {
  if (items.length <= maxShown) return items.join(', ');
  return `${items.slice(0, maxShown).join(', ')}… (+${
    items.length - maxShown
  } more)`;
}

export function formatPhysicianName(p: ClinicPhysicianResponse): string {
  const suffix = p.suffix ? `, ${p.suffix}` : '';
  return `${p.first_name} ${p.last_name}${suffix}`;
}
